import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea9318j6pdzpd0vd as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_isFailure__impl__jpiriv2lptaeb4c2198 as _Result___get_isFailure__impl__jpiriv,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { pipelineStartCoroutineUninterceptedOrReturn3fvxhza76tp2 as pipelineStartCoroutineUninterceptedOrReturn } from './PipelineJs.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { recoverStackTraceBridge1qu82j8ymuquf as recoverStackTraceBridge } from './StackTraceRecover.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function loop($this, direct) {
  do {
    var currentIndex = $this.u4r_1;
    if (currentIndex === $this.p4r_1.q2()) {
      if (!direct) {
        // Inline function 'kotlin.Companion.success' call
        var value = $this.r4r_1;
        var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
        resumeRootWith($this, tmp$ret$0);
        return false;
      }
      return true;
    }
    $this.u4r_1 = currentIndex + 1 | 0;
    var next = $this.p4r_1.r2(currentIndex);
    try {
      var result = pipelineStartCoroutineUninterceptedOrReturn(next, $this, $this.r4r_1, $this.q4r_1);
      if (result === get_COROUTINE_SUSPENDED())
        return false;
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
        resumeRootWith($this, tmp$ret$1);
        return false;
      } else {
        throw $p;
      }
    }
  }
   while (true);
}
function resumeRootWith($this, result) {
  if ($this.t4r_1 < 0) {
    // Inline function 'kotlin.error' call
    var message = 'No more continuations to resume';
    throw IllegalStateException().o(toString(message));
  }
  var next = ensureNotNull($this.s4r_1[$this.t4r_1]);
  var _unary__edvuaz = $this.t4r_1;
  $this.t4r_1 = _unary__edvuaz - 1 | 0;
  $this.s4r_1[_unary__edvuaz] = null;
  if (!_Result___get_isFailure__impl__jpiriv(result)) {
    next.oc(result);
  } else {
    var exception = recoverStackTraceBridge(ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result)), next);
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
    next.oc(tmp$ret$2);
  }
}
function discardLastRootContinuation($this) {
  if ($this.t4r_1 < 0)
    throw IllegalStateException().o('No more continuations to resume');
  var _unary__edvuaz = $this.t4r_1;
  $this.t4r_1 = _unary__edvuaz - 1 | 0;
  $this.s4r_1[_unary__edvuaz] = null;
}
var SuspendFunctionGun$continuation$1Class;
function SuspendFunctionGun$continuation$1() {
  if (SuspendFunctionGun$continuation$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.w4r_1 = this$0;
        this.v4r_1 = -2147483648;
      }
      mc() {
        var continuation = this.w4r_1.s4r_1[this.w4r_1.t4r_1];
        if (!(continuation === this) && !(continuation == null))
          return continuation.mc();
        var index = this.w4r_1.t4r_1 - 1 | 0;
        while (index >= 0) {
          var _unary__edvuaz = index;
          index = _unary__edvuaz - 1 | 0;
          var cont = this.w4r_1.s4r_1[_unary__edvuaz];
          if (!(cont === this) && !(cont == null))
            return cont.mc();
        }
        // Inline function 'kotlin.error' call
        var message = 'Not started';
        throw IllegalStateException().o(toString(message));
      }
      tk(result) {
        if (_Result___get_isFailure__impl__jpiriv(result)) {
          // Inline function 'kotlin.Companion.failure' call
          var exception = ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result));
          var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
          resumeRootWith(this.w4r_1, tmp$ret$0);
          return Unit_instance;
        }
        loop(this.w4r_1, false);
      }
      oc(result) {
        return this.tk(result);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Continuation()]);
    SuspendFunctionGun$continuation$1Class = $;
  }
  return SuspendFunctionGun$continuation$1Class;
}
var SuspendFunctionGunClass;
function SuspendFunctionGun() {
  if (SuspendFunctionGunClass === VOID) {
    class $ extends PipelineContext() {
      constructor(initial, context, blocks) {
        super(context);
        this.p4r_1 = blocks;
        var tmp = this;
        tmp.q4r_1 = new (SuspendFunctionGun$continuation$1())(this);
        this.r4r_1 = initial;
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.p4r_1.q2();
        tmp_0.s4r_1 = Array(size);
        this.t4r_1 = -1;
        this.u4r_1 = 0;
      }
      xv() {
        return this.q4r_1.mc();
      }
      h4q() {
        return this.r4r_1;
      }
      *j4q($completion) {
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        return yield () => {
          var tmp0 = $completion;
          var tmp$ret$1;
          $l$block_0: {
            if (this.u4r_1 === this.p4r_1.q2()) {
              tmp$ret$1 = this.r4r_1;
              break $l$block_0;
            }
            this.x4r(intercepted(tmp0));
            if (loop(this, true)) {
              discardLastRootContinuation(this);
              tmp$ret$1 = this.r4r_1;
              break $l$block_0;
            }
            tmp$ret$1 = get_COROUTINE_SUSPENDED();
          }
          return tmp$ret$1;
        };
      }
      *i4q(subject, $completion) {
        this.r4r_1 = subject;
        return yield* this.j4q($completion);
      }
      *k4q(initial, $completion) {
        this.u4r_1 = 0;
        if (this.u4r_1 === this.p4r_1.q2())
          return initial;
        this.r4r_1 = initial;
        if (this.t4r_1 >= 0)
          throw IllegalStateException().o('Already started');
        return yield* this.j4q($completion);
      }
      x4r(continuation) {
        this.t4r_1 = this.t4r_1 + 1 | 0;
        this.s4r_1[this.t4r_1] = continuation;
      }
    }
    initMetadataForClass($, 'SuspendFunctionGun', VOID, VOID, VOID, [0, 1]);
    SuspendFunctionGunClass = $;
  }
  return SuspendFunctionGunClass;
}
//region block: exports
export {
  SuspendFunctionGun as SuspendFunctionGun278ui80hj12zj,
};
//endregion

//# sourceMappingURL=SuspendFunctionGun.mjs.map
